module.exports = __webpack_public_path__ + "static/img/nothing1.b26cbfa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/nothing1.png
// module id = 9ot2
// module chunks = 1